import { render, staticRenderFns } from "./DeclarationsJudiciaires.vue?vue&type=template&id=105aa686"
import script from "./DeclarationsJudiciaires.vue?vue&type=script&lang=js"
export * from "./DeclarationsJudiciaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports